module.exports = __webpack_public_path__ + "static/4-ff2202fa8caecfe7b0cf1459dd2c6aa8.png";